import Vue from 'vue'
import { decode } from '@/lib/util'

export default el => new Vue({
  name: 'Key Ingredients',
  el,
  data() {
    const dataItems = el.dataset?.section ? JSON.parse(decode(el.dataset?.section)) : false
    return {
      dataItems,
      index: 0,
      breakpoints: '(max-width: 767px)|(min-width: 768px)'
    }
  },
  watch: {
    index (val) {
      this.$nextTick(() => {
        this.setHeight(val)
      })
    }
  },
  computed: {
    visibleItem () {
      if (this.dataItems && this.dataItems?.settings.length) {
        return this.dataItems.settings.find(item => item.index === this.index)
      }

      return false
    },
    imageSources () {
      if (!this.visibleItem) return
      const images = []
      if (this.visibleItem.imageMobile) images.push(this.visibleItem.imageMobile)
      if (this.visibleItem.imageDesktop) images.push(this.visibleItem.imageDesktop)
      return images
    }
  },
  methods: {
    setHeight(id) {
      const content = `contentWrapper-${id}`
      if (this.$refs[content] && this.$refs.content) {
        this.$refs.content.style.height = `${this.$refs[content].offsetHeight + 64}px`
      }
    }
  }
})
